import { render, staticRenderFns } from "./FixedShare.vue?vue&type=template&id=4df22738&scoped=true&"
import script from "./FixedShare.vue?vue&type=script&lang=js&"
export * from "./FixedShare.vue?vue&type=script&lang=js&"
import style0 from "./FixedShare.vue?vue&type=style&index=0&id=4df22738&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df22738",
  null
  
)

export default component.exports